import type { IssueView } from '@/types/issue';

const VIEW_TOKEN = /\bis:(?:active|backlog)\b/gi;

export function issueQueryView(q: string): IssueView {
  if (/\bis:backlog\b/i.test(q)) return 'backlog';
  if (/\bis:active\b/i.test(q)) return 'active';
  return 'all';
}

export function stripViewTokens(q: string): string {
  return collapse(q.replace(VIEW_TOKEN, ' '));
}

export function setIssueQueryView(q: string, view: IssueView): string {
  const rest = stripViewTokens(q);
  if (view === 'backlog') return joinQuery(['is:backlog', rest]);
  if (view === 'all') return rest;
  return joinQuery(['is:active', rest]);
}

export function setAssigneeToken(q: string, token: string | null): string {
  return replaceKind(q, [/\bassignee:[^\s]+/gi, /\bis:unassigned\b/gi], token);
}

export function setStatusToken(q: string, status: string | null): string {
  return replaceKind(q, [/\bstatus:[^\s]+/gi], status ? `status:${status}` : null);
}

export function setPriorityToken(q: string, priority: string | null): string {
  return replaceKind(q, [/\bpriority:[^\s]+/gi], priority ? `priority:${priority}` : null);
}

export function setLabelToken(q: string, name: string | null): string {
  return replaceKind(q, [/\blabel:[^\s]+/gi], name ? `label:${name}` : null);
}

export function setShowCompleted(q: string, show: boolean): string {
  const without = collapse(q.replace(/\s*OR\s+status:done\b/gi, ' '));
  if (show) {
    return without ? `${without} OR status:done` : 'status:done';
  }
  return without;
}

export function hasShowCompleted(q: string): boolean {
  return /\bOR\s+status:done\b/i.test(q);
}

export function issueQueryChipTokens(q: string): string[] {
  return (q.match(/(?:[^\s"]+|"[^"]+")/g) ?? []).filter((token) => {
    if (token.toUpperCase() === 'OR') return false;
    return !/^is:(active|backlog)$/i.test(token);
  });
}

function replaceKind(q: string, kinds: RegExp[], token: string | null): string {
  let next = q;
  kinds.forEach((pattern) => {
    next = next.replace(pattern, ' ');
  });
  next = collapse(next);
  if (!token) return next;
  return joinQuery([next, token]);
}

function joinQuery(parts: string[]): string {
  return collapse(parts.filter((part) => part.trim().length > 0).join(' '));
}

function collapse(value: string): string {
  return value.replace(/\s+/g, ' ').trim();
}
